import {
  DashboardOutlined,
  AppstoreOutlined,
  CalendarOutlined,
  WalletOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  FieldTimeOutlined,
  HddOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
  WarningOutlined,
  DollarOutlined,
  BankOutlined,
  FileTextOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AdminUserMenu from './AdminUserMenu';
import { stripPathLanguage } from '../../i18nLanguages';
import MyButtonText from '../../components/myButton/MyButtonText';
const getSelectedKey = (pathname) => {
  if (pathname.startsWith('/dashboard')) return '/dashboard';
  if (
    pathname.startsWith('/definitions') ||
    pathname.startsWith('/country') ||
    pathname.startsWith('/state') ||
    pathname.startsWith('/city') ||
    pathname.startsWith('/constants')
  )
    return '/definitions';
  if (pathname.startsWith('/monthly_variables')) return '/monthly_variables';
  if (pathname.startsWith('/loans_management')) return '/loans_management';
  if (pathname.startsWith('/bank_accounts')) return '/bank_accounts';
  if (
    pathname.startsWith('/reports') ||
    pathname.startsWith('/report_monthly_salaries') ||
    pathname.startsWith('/report_temporary_monthly_salaries') ||
    pathname.startsWith('/report_salary_block_all_departments') ||
    pathname.startsWith('/report_insured_salaries') ||
    pathname.startsWith('/report_union_subscriptions') ||
    pathname.startsWith('/report_employee_paid_salaries') ||
    pathname.startsWith('/report_bank_account_statement') ||
    pathname.startsWith('/report_total_employee_salaries')
  )
    return '/reports';
  if (pathname.startsWith('/employees_management'))
    return '/employees_management';
  if (pathname.startsWith('/groups_management')) return '/groups_management';
  if (pathname.startsWith('/leaves_and_tasks')) return '/leaves_and_tasks';
  if (pathname.startsWith('/attendance_records')) return '/attendance_records';
  if (pathname.startsWith('/error_processing')) return '/error_processing';
  if (pathname.startsWith('/device_settings')) return '/device_settings';
  if (pathname.startsWith('/profile')) return '/profile';
  return pathname;
};

const SALARIES_CHILD_KEYS = [
  '/monthly_variables',
  '/loans_management',
  '/bank_accounts',
];

const ATTENDANCE_CHILD_KEYS = [
  '/attendance_records',
  '/leaves_and_tasks',
  '/error_processing',
  '/device_settings',
];

const getOpenKeys = (selectedKey) => {
  if (SALARIES_CHILD_KEYS.includes(selectedKey)) return ['salaries'];
  if (ATTENDANCE_CHILD_KEYS.includes(selectedKey)) return ['attendance'];
  return [];
};

const AdminSider = ({ onSelect, collapsed, onCollapse }) => {
  const { pathname } = useLocation();
  const selectedKey = getSelectedKey(stripPathLanguage(pathname));
  const { t } = useTranslation();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: t('WORD_DASHBOARD'),
    },
    {
      key: '/definitions',
      icon: <AppstoreOutlined />,
      label: t('WORD_DEFINITIONS'),
    },
    {
      key: '/employees_management',
      icon: <TeamOutlined />,
      label: t('WORD_STAFF_MANAGEMENT'),
    },
    {
      key: 'salaries',
      icon: <DollarOutlined />,
      label: t('WORD_SALARIES'),
      children: [
        {
          key: '/monthly_variables',
          icon: <CalendarOutlined />,
          label: t('WORD_MONTHLY_VARIABLES'),
        },
        {
          key: '/loans_management',
          icon: <WalletOutlined />,
          label: t('WORD_LOANS_MANAGEMENT'),
        },
        {
          key: '/bank_accounts',
          icon: <BankOutlined />,
          label: t('WORD_BANK_ACCOUNT_NUMBERS'),
        },
      ],
    },
    {
      key: 'attendance',
      icon: <ClockCircleOutlined />,
      label: t('WORD_ATTENDANCE_SECTION'),
      children: [
        {
          key: '/attendance_records',
          icon: <FieldTimeOutlined />,
          label: t('WORD_ATTENDANCE_RECORDS'),
        },
        {
          key: '/leaves_and_tasks',
          icon: <CarryOutOutlined />,
          label: t('WORD_LEAVES_AND_TASKS'),
        },
        {
          key: '/error_processing',
          icon: <WarningOutlined />,
          label: t('WORD_ERROR_PROCESSING'),
        },
        {
          key: '/device_settings',
          icon: <HddOutlined />,
          label: t('WORD_DEVICE_SETTINGS'),
        },
      ],
    },
    {
      key: '/reports',
      icon: <FileTextOutlined />,
      label: t('WORD_REPORTS'),
    },
    {
      key: '/groups_management',
      icon: <UsergroupAddOutlined />,
      label: t('WORD_GROUPS_MANAGEMENT'),
    },
  ];

  return (
    <div className="admin_sider_inner">
      <div className="admin_brand">
        {!collapsed && (
          <>
            <div className="admin_brand_mark">F</div>
            <div className="admin_brand_text">
              <strong>salary</strong>
              <span>{t('WORD_ADMIN')}</span>
            </div>
          </>
        )}
        <MyButtonText
          className="admin_collapse_btn"
          onClick={onCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </MyButtonText>
      </div>

      <Menu
        mode="inline"
        items={menuItems}
        selectedKeys={[selectedKey]}
        defaultOpenKeys={getOpenKeys(selectedKey)}
        onClick={({ key }) => {
          if (key.startsWith('/')) onSelect?.(key);
        }}
        className="admin_menu"
      />

      <div className="admin_sider_footer">
        <AdminUserMenu />
      </div>
    </div>
  );
};

export default AdminSider;
